"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageKeys = void 0;
var LocalStorageKeys;
(function (LocalStorageKeys) {
    LocalStorageKeys["LRMiddleNames"] = "LRMiddleNames";
    LocalStorageKeys["isFirstTimeVisitor"] = "isFirstTimeVisitor";
    LocalStorageKeys["currentSavings"] = "currentSavings";
    LocalStorageKeys["webComponentOverride"] = "webComponentOverride";
    LocalStorageKeys["localWebComponents"] = "localWebComponents";
    LocalStorageKeys["coderWebComponents"] = "coderWebComponents";
    LocalStorageKeys["inactiveWebComponents"] = "inactiveWebComponents";
    LocalStorageKeys["webComponentsPkgOverrides"] = "webComponentsPkgOverrides";
    LocalStorageKeys["ClientTimeoutSpoid"] = "ClientTimeoutSpoid";
    LocalStorageKeys["coderPrefix"] = "coderPrefix";
    LocalStorageKeys["tNumber"] = "tNumber";
    LocalStorageKeys["mockedServices"] = "mockedServices";
    LocalStorageKeys["mockedServicesToRefresh"] = "mockedServicesToRefresh";
    LocalStorageKeys["devToolIgnoreFlowOverride"] = "devToolIgnoreFlowOverride";
    LocalStorageKeys["devToolFeatureOverride"] = "devToolFeatureOverride";
})(LocalStorageKeys = exports.LocalStorageKeys || (exports.LocalStorageKeys = {}));
